
export const isEmpty = (obj) => {
  let error =""
 if (Object.values(obj).some(el => !el)) {
    error = "Mandatory details cannot be empty"
  } 
  return error
};